import type { ReactNode } from "react";

type Props = {
  /** Glyph shown in the accent square — a lucide icon sized h-3.5 w-3.5. */
  icon: ReactNode;
  title: string;
  subtitle: string;
  /** When given, the lockup becomes a link (the brand → home page convention). */
  href?: string | undefined;
};

/** PFL LIVCG identity lockup — accent glyph square + wordmark + subtitle.
 *  Shared by every workspace topbar so the brand is defined in one place
 *  (and updates everywhere once the official brand sheet lands). */
export function BrandMark({ icon, title, subtitle, href }: Props) {
  const body = (
    <>
      <span className="grid h-8 w-8 place-items-center rounded-md border border-accent-strong/30 bg-accent/10 text-accent-strong">
        {icon}
      </span>
      <div className="leading-tight">
        <div className="text-[14px] font-semibold text-ink tracking-[-0.01em]">{title}</div>
        <div className="t-mono">{subtitle}</div>
      </div>
    </>
  );
  if (href) {
    return (
      <a href={href} className="flex items-center gap-3 rounded-md transition-opacity hover:opacity-80">
        {body}
      </a>
    );
  }
  return <div className="flex items-center gap-3">{body}</div>;
}
